/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tooltip[_ngcontent-%COMP%]{position:relative;display:inline-block}.tooltip[_ngcontent-%COMP%]   .tooltiptext[_ngcontent-%COMP%]{visibility:hidden;background-color:#fff;color:#000;border-radius:6px;padding:10px;border:1px solid #e2e8f0;position:absolute;z-index:1}.tooltip[_ngcontent-%COMP%]:hover   .tooltiptext[_ngcontent-%COMP%]{visibility:visible}.top[_ngcontent-%COMP%]{bottom:100%}.bottom[_ngcontent-%COMP%]{top:100%}.left[_ngcontent-%COMP%]{right:0}.right[_ngcontent-%COMP%]{left:0}\n/*# sourceMappingURL=tooltip.component.css.map*/"];
export { styles as styles };
